<script lang="ts">
  import { ProductLineListingStore } from "@retailer/svelte/ProductLines/ProductLineContainer/stores/ProductLineListingStore";
  import ProductCard from "@shared/svelte/Components/ProductLines/ProductCard.svelte";
  import { slice } from "lodash";
  import { getPricesForSearchResult } from "@retailer/services/pricing_data_service";

  import type { ProductLine, InventoryPrice } from "@shared/types/ProductLine";
  import InventoryStatusStore from "@shared/svelte/Stores/InventoryStatusStore";
  import { onDestroy } from "svelte";

  export let productLines: ProductLine[];
  export let cardWidth: number = null;
  export let stateParams;
  export let startingIndex;
  export let useStoreForCardData: boolean = true;
  export let trackProductIndexLayout: boolean = false;

  let loadingPrices: boolean = true;
  let inventoryPrices: InventoryPrice[] = [];
  let unsubscribe = () => {};

  $: inventoryStatuses = $InventoryStatusStore.inventoryStatuses;

  if (useStoreForCardData) {
    unsubscribe = ProductLineListingStore.subscribe(n => {
      loadingPrices = n.loadingPrices;
      inventoryPrices = n.inventoryPrices;
    });
  } else {
    if (productLines.length) {
      getPricesForSearchResult(productLines)
        .then(response => {
          inventoryPrices = response;
        })
        .catch(() => {
          inventoryPrices = [];
        })
        .finally(() => {
          loadingPrices = false;
        });
    }
  }

  onDestroy(() => {
    unsubscribe();
  });
</script>

{#each slice(productLines, 0, 1) as productLine (productLine.id)}
  <div class="product-result-tile-fizz" bind:clientWidth={cardWidth}>
    <ProductCard
      {productLine}
      index={startingIndex}
      {stateParams}
      {trackProductIndexLayout}
      bind:loadingPrices
      {inventoryPrices}
      bind:inventoryStatuses={inventoryStatuses[productLine.id]}
    />
  </div>
{/each}

{#each slice(productLines, 1) as productLine, index (productLine.id)}
  <div class="product-result-tile-fizz">
    <ProductCard
      {productLine}
      index={startingIndex + index + 1}
      {stateParams}
      {trackProductIndexLayout}
      bind:loadingPrices
      {inventoryPrices}
      bind:inventoryStatuses={inventoryStatuses[productLine.id]}
    />
  </div>
{/each}
